import React from 'react';
import './index.css';

function AsideCard ({children}) {
	return (
		<div className="card aside-card">
			{children}
		</div>
	)
}

export default AsideCard;
